import Vue from 'vue'
import Router from 'vue-router'
import Layout from './layout/index.vue'
import Home from './views/home'
import Homev2 from './views/home/homev2.vue'
import NotFound from './views/errView/NotFound.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/home',
    },
    {
      path: '/index',
      redirect: '/home',
    },

    {
      path: '',
      name: 'layout',
      component: Layout,
      children: [
        {
          path: '/home',
          name: 'h5v2home',
          meta: {
            title: 'AINVEST',
          },
          component: Homev2,
        },
        {
          path: '/strategylist',
          name: 'strategylist',
          meta: {
            title: '投顾列表',
          },
          component: () => import('./views/strategy/listv2.vue'),
        },
        // {
        //   path: '/jsyl',
        //   name: 'jsyl',
        //   meta: {
        //     title: '金声玉亮2.0',
        //     requiresAuth: true,
        //   },
        //   component: () => import('./views/jsyl/index.vue'),
        // },
        // {
        //   path: '/jsyl/',
        //   name: 'jsyl',
        //   meta: {
        //     title: '金声玉亮2.0',
        //     requiresAuth: true,
        //   },
        //   component: () => import('./views/jsyl/index.vue'),
        // },
        {
          path: '/jsyl',
          name: 'jsyl',
          meta: {
            title: '金声玉亮3.0',
          },
          component: () => import('./views/jsylNew/index.vue'),
        },
        // {
        //   path: '/jsyl/textTalk',
        //   name: 'jsylTextTalk',
        //   meta: {
        //     title: '文字对话',
        //   },
        //   component: () => import('./views/jsylNew/text-talk.vue'),
        // },
        {
          path: '/jsyl/voiceTalk/:id?',
          name: 'jsylVoiceTalk',
          meta: {
            title: '语音对话',
          },
          component: () => import('./views/jsylNew/voice-talk.vue'),
        },
        {
          path: '/user/:openNow?',
          name: 'user',
          meta: {
            title: '用户中心',
          },
          component: () => import('./views/user/index.vue'),
        },
      ],
    },
    {
      path: '/strategy/detail/:id/',
      name: 'strategyDetail',
      meta: {
        title: '投顾详情',
      },
      component: () => import('./views/strategy/detail.vue'),
    },
    {
      path: '/strategy/analytics',
      name: 'strategyAnalytics',
      meta: {
        title: '策略分析',
      },
      component: () => import('./views/strategy/strategy-analytics.vue'),
    },
    {
      path: '/userConfig',
      name: 'userConfig',
      meta: {
        title: '用户配置',
      },
      component: () => import('./views/userConfig/index.vue'),
    },
    {
      path: '/cloudServer',
      name: 'cloudServer',
      meta: {
        title: '用户配置',
      },
      component: () => import('./views/userConfig/cloudServer.vue'),
    },
    {
      path: '/carouselDemo',
      name: 'carouselDemo',
      meta: {
        title: '轮播弹窗演示',
      },
      component: () => import('./components/WelcomeCarouselDemo.vue'),
    },
    {
      path: '/qrCodeDemo',
      name: 'qrCodeDemo',
      meta: {
        title: '二维码弹窗演示',
      },
      component: () => import('./views/qrCodeDemo/index.vue'),
    },
    {
      path: '/subscription',
      name: 'subscription',
      meta: {
        title: '服务器套餐',
      },
      component: () => import('./views/subscription/index.vue'),
    },
    {
      path: '/recharge-history',
      name: 'rechargeHistory',
      meta: {
        title: '充值记录',
      },
      component: () => import('./views/subscription/history.vue'),
    },
    {
      path: '/chat',
      name: 'chat',
      meta: {
        title: '联系客服',
      },
      component: () => import('./views/chat/v1qrcode.vue'),
    },
    {
      path: '/register/:phone?',
      name: 'register',
      meta: {
        title: '注册',
      },
      component: () => import('./views/register/v2.vue'),
    },
    {
      path: '/regLogin/:islogin?',
      name: 'regLogin',
      meta: {
        title: '注册/登录',
      },
      component: () => import('./views/regLogin/regLogin.vue'),
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        title: '登录',
      },
      component: () => import('./views/login/index.vue'),
    },
    {
      path: '/yidao',
      name: 'yidao',
      meta: {
        title: '一刀智投 3.0',
      },
      component: () => import('./views/yidao/index.vue'),
    },
    {
      path: '/strategylist3',
      name: 'strategylist3',
      meta: {
        title: '投顾列表',
      },
      component: () => import('./views/strategy/listv3.vue'),
    },
    {
      path: '/pay',
      name: 'pay',
      meta: {
        title: '支付',
      },
      component: () => import('./views/pay/v12.vue'),
    },
    {
      path: '/pay/result',
      name: 'payResult',
      meta: {
        title: '支付结果',
      },
      component: () => import('./views/pay/result.vue'),
    },
    {
      path: '/proxy/apply',
      nanme: 'proxy-apply',
      meta: {
        title: '申请成为合伙人',
      },
      component: () => import('./views/proxy/info.vue'),
    },
    {
      path: '/userservice',
      name: 'userservice',
      meta: {
        title: '用户服务协议',
      },
      component: () => import('./views/userservice/userservice_v3.vue'),
    },
    {
      path: '/privacypollcy',
      name: 'privacypollcy',
      meta: {
        title: '用户服务协议',
      },
      component: () => import('./views/userservice/privacyPollcy.vue'),
    },
    {
      path: '/partnership',
      name: 'partnership',
      meta: {
        title: '合伙人计划',
      },
      component: () => import('./views/partnership'),
    },
    {
      path: '/holdingdetail',
      name: 'holdingDetail',
      meta: {
        title: '持仓收益',
      },
      component: () => import('./views/holdingdetail'),
    },
    { path: '*', component: NotFound },
  ],
});

router.beforeEach((to, from, next) => {
	try {
		// 处理根路径访问
		if (to.path === '/' || to.path === '/index' || to.path === '') {
			next('/home')
			return
		}
		
		next()
	} catch (error) {
		console.warn('路由守卫异常:', error);
		next();
	}
})

export default router

